import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            companiesPayments: [],
            partnerCompanies: [],
            namesForPartner: LocService.t('label_name_for_partner'),
            customCategory: '',
            isEnableGender: false,
            hiddenColumns: CONFIG_COMPANY.HIDDEN_COLUMNS_USER_TABLE ,
            showUserAdditionalInfo: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO ,
            showUserAdditionalInfoLessonUrl: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO_LESSON_URL,
            customCategories: [],
            userTypes: [],
            role: '',
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                role: 'ROLE_USER',
                username: '',
                paidDate: null,
                expireDate: null,
                birthday: null,
                shoesSize: null,
                userInfo: null,
                lessonUrl: null,
                restOfTraining: 0,
                companyPayment: null,
                partnerCompany: null,
                customCategory: '',
                userType: null,
                gender: null,
                isMainAdmin: null,
            },
            showPartners: false
        }
    },
    methods: {
        register : register,
        loadSaradnici: loadSaradnici,
        addPaymentToUser: addPaymentToUser,
        deleteSaradnik: deleteSaradnik,
        loadCompanyPartner: loadCompanyPartner,
        clear : clear
    },
    beforeMount() {
        this.role = session.getRole();
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

        this.customCategory = session.getConfig().customCategory == null ? '' : session.getConfig().customCategory
        if(session.getConfig().customCategories != null){
            this.customCategories = session.getConfig().customCategories.split(";")
        }
        if(CONFIG_COMPANY.USER_TYPES != null){
            this.userTypes = CONFIG_COMPANY.USER_TYPES;
            if(this.userTypes.length === 1){
                this.model.userType = this.userTypes[0].id
            }
        }
        this.isEnableGender = CONFIG_COMPANY.ENABLE_GENDER != null ? CONFIG_COMPANY.ENABLE_GENDER : false;

        this.loadSaradnici();
        this.loadCompanyPartner();
    }
}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function clear() {
    this.model.email = '';
    this.model.name = '';
    this.model.phone = '';
    this.model.surname = '';
    this.model.role = 'ROLE_USER';
    this.model.username = '';
    this.model.paidDate = null;
    this.model.expireDate = null;
    this.model.birthday = null;
    this.model.shoesSize = null;
    this.model.lessonUrl = null;
    this.model.restOfTraining = 0;
    this.model.companyPayment= null;
    this.model.partnerCompany= null;
    this.model.userInfo= null;
    this.model.customCategory= '';
    this.model.userType= null;
    this.model.gender= null;
    this.model.isMainAdmin = null;
}

function register() {
    let _self = this;
    // this.model.paidDate =this.model.paidDate + 'T00:00:00.000Z';
    // this.model.expireDate =this.model.expireDate + 'T00:00:00.000Z';
    if(this.model.birthday != null){
        this.model.birthday = this.model.birthday + 'T08:00:00.000Z';
    }
    AdminApiService.registerUser(this.model)
        .then((response) => {
           // swal( LocService.t('label_success'),LocService.t('label_user_added'),'success')
           _self.clear();
           _self.addPaymentToUser(response.data);
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}
function addPaymentToUser(user){
    if(this.hiddenColumns.includes('BUTTON_PAYMENTS')) {
        swal( LocService.t('label_success'),LocService.t('label_user_added'),'success')
        return
    }
    let _self = this;
    swal({
        title: LocService.t('label_success'),
        text: LocService.t('label_user_added_success_add_payment'),
        type: 'success',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$router.push('/user-profile?id=' +  user.id + '&name=' + user.name + ' ' + user.surname + '&type=payments')
    });
}

function loadSaradnici() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.companiesPayments = response.data
            let showPartners = session.getConfig().enablePartnersForRegister == null ? false : session.getConfig().enablePartnersForRegister
            _self.showPartners = showPartners && response.data.length > 0
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteSaradnik(){
    this.model.companyPayment = null;
}


// WEBPACK FOOTER //
// ./src/components/Users/Add/AddUser.js